/* tslint:disable */
/* eslint-disable */
export enum ServiceordreValidationFailedReasonEnum {
  CreditCheckFailed = 'CreditCheckFailed',
  MultipleEftersynInServiceInterval = 'MultipleEftersynInServiceInterval'
}
